export default __webpack_public_path__ + "static/media/Áreas de Concentração e Linhas de Pesquisa Mestrado e Plano Curricular.15d250a4.pdf";